<template>
  <!-- Modal -->
  <div>
    <form-text ref="name" label="Name" name="input" v-model="temperature.name" validation="required"></form-text>
  </div>
</template>

<script>
import FormText from '../../../elements/Form/FormText'

export default {
  components:{
    'form-text': FormText,
  },
  data() {
    return {
      temperature: {
        name: '',
      },
    }
  }
}
</script>


// WEBPACK FOOTER //
// Temperature.vue?8e9518aa